Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentNewsCommentView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_news_comment"]
  className: 'sc-news-comment-source'

  initialize: (options = {}) ->
    @socialContent = options.socialContent

  render: ->
    @$el.html @template
      title:
        text: @socialContent.getValue('title')
        url: @socialContent.getValue('url')
      source: @socialContent.getValue('source')
    this
